module.exports = __webpack_public_path__ + "static/media/go.1a9c888f.mp3";